import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { CommonService } from '../../services/common.service';
import * as moment from 'moment';

declare var $: any;

@Component({
  selector: 'app-general',
  templateUrl: './general.component.html',
  styleUrls: ['./general.component.css']
})
export class GeneralComponent implements OnInit {

  @Input() detail;
  @Input() position;
  @Input() edit: Boolean;
  @Input() add: Boolean;
  @Input() hidetitle: Boolean;
  @Input() listeagence;
  @Input() listeSociete;
  @Input() agence;
  @Output() editfct = new EventEmitter<any>();
  @Output() createfct = new EventEmitter<any>();
  @Output() showContact = new EventEmitter<any>();
  @Output() showUserEcoportail = new EventEmitter<any>();
  @Output() showDocument = new EventEmitter<any>();
  @Output() showEntTravaux = new EventEmitter<any>();
  @Output() editfctagence = new EventEmitter<any>();
  @Output() createfctagence = new EventEmitter<any>();
  @Output() showGestionFIPDD = new EventEmitter<any>();
  @Output() showGestionFIPDND = new EventEmitter<any>();
  default = 0;
  nbdigit;
  result: any[] = [];
  listeChantier: any[] = [];
  isCodeClientAuto: Boolean = false;
  isInfoPart: Boolean = false;
  civilite;
  civiliteFact;
  paysF;
  paysEnvoie;
  chantier: any = {};
  listPays = [];
  listCivilite = [];
  listActivite = [];
  dataSiren = [];
  visibiliteValue = '';
  choixVisibilite: any[] = [
    { id: 1, libelle: 'Tous les modules' },
    { id: 2, libelle: 'Tous les modules sauf Ecopol' },
    { id: 3, libelle: 'Définir' }
  ];

  /*searchAdresseBAK: any[] = [];*/
  dataAdresseBAK: any[] = [];
  listModules: any[] = [];
  objFileObject: any = {};
  cheminLogo: any = '';
  droitEcoGED: any = {};
  adresseDestClient: any = {};
  selectedModule = [];
  tempListeModule = [];
  societe: any = {};
  adresseAutoBAK: Boolean = false;
  codeProspectAuto: Boolean = false;
  resultAgence = [];
  typeClientParticulier;
  typeClientProfessionnel;
  droit: any = {};
  user;
  change: any = {};
  site: any = {};
  masqueModificationExterne: Boolean = false;
  isInfoSiretOpen = false;
  listOperationBennePortail:any[] = [];
  delay;
  isprenomObligatoire : Boolean = false;
  @ViewChild('adEnvMail') adEnvMail;
  @ViewChild('visibilite') visibilite;
  @ViewChild('logo') logo;
  @ViewChild('droitEcoPortail') droitEcoPortail;
  @ViewChild('accesWidgetEcoPortail') accesWidgetEcoPortail;
  @ViewChild('choixOperationBennePortail') choixOperationBennePortail;

  listeAssoClientWidgetEcoPortailTmp = []; // Pour pouvoir annuler les modifications

  constructor(public common: CommonService, private modalService: BsModalService) {
  }

  ngOnInit() {
    this.user = this.common.local.getObject('userDetail') || {};
    this.droit['droitFicheGen'] = ((this.user.clefDroit & 0x00040000) !== 0) ? true : false;
    this.isInfoPart = this.common.activedModule === 4 ? true : false;
    this.societe = this.common.local.getObject('paramSociete') || {};
    this.site = this.common.getType('siteUtilisateur');
    const adresseAutoBAK = this.site['rechercheAdresse'] && (this.site['serviceAdresse'] &&
      this.site['serviceAdresse'].typeServiceAdresse &&
      this.site['serviceAdresse'].typeServiceAdresse.id === 2) ? true : false;
    this.adresseAutoBAK = (this.societe['rechercheAdresse'] && (this.societe['serviceAdresse'] &&
      this.societe['serviceAdresse'].typeServiceAdresse &&
      this.societe['serviceAdresse'].typeServiceAdresse.id === 2)) || adresseAutoBAK;
    this.codeProspectAuto = this.common.local.getObject('paramSociete').codeProspectAuto || false;
    this.nbdigit = this.common.local.getObject('paramSociete').nbDigitDevise;
    this.isCodeClientAuto = this.common.local.getObject('paramSociete').codeClientAuto || false;
    this.civilite = this.common.getItem(this.common.getType('typeCivilite'), (this.detail.civilite ? this.detail.civilite.id : 0));
    this.civiliteFact = this.common.getItem(this.common.getType('typeCivilite'), (this.detail.civiliteFact ? this.detail.civiliteFact.id : 0));
    this.paysF = this.common.getItem(this.common.getType('typePays'), (this.detail.paysF ? this.detail.paysF.id : 0));
    this.paysEnvoie = this.common.getItem(this.common.getType('typePays'), (this.detail.paysEnvoie ? this.detail.paysEnvoie.id : 0));
    this.masqueModificationExterne = this.societe.URLCreationClient ? true : false;

    const clefTypeClientParticulier = this.societe['typeClientParticulier'] || 0;
    if (this.add && this.common.activedModule === 4) {
      this.detail['type'] = { id: clefTypeClientParticulier };
    }
    this.common.getType('typeClient').forEach(elt => {
      if (elt.id === clefTypeClientParticulier) {
        this.typeClientParticulier = elt;
      } else if (elt.libelle === 'Professionnel') { //Pro
        this.typeClientProfessionnel = elt
      }
    });
    this.searchType();

    this.searchCivilite();
    this.searchPays();
    this.getListModule();
    this.common.getDetailBak(this.adresseAutoBAK, this.detail['clefBAK']);

    if (this.add && this.detail['prospect'] && this.societe['codeProspectAuto']) {
      this.detail['codeProspect'] = '.';
    }

    this.verifyPrenom();
    this.getListOperationBennePortail().then(() => {
      if (this.detail['id'] && this.detail['id'] != 0) {
         this.traiterOperationBennePortailVisible();
      } else {
        this.listOperationBennePortail.forEach(el => {
          el.operationBenneVisiblePortailClient = true;
        });
        this.detail['listOperationBenne'] = this.listOperationBennePortail ||[];  
        
      }
    })

  }

  addChantier() {
    this.createfct.emit();
  }

  editChantier() {
    this.editfct.emit(this.chantier);
  }

  searchPays(event?) {
    this.listPays = [];
    this.common.getType('typePays').forEach(elt => {
      const eventLowerCase = !!event ? event.toLowerCase() : '';
      const libelleToLowerCase = !!elt.libelle ? elt.libelle.toLowerCase() : '';
      if (libelleToLowerCase.startsWith(eventLowerCase) || libelleToLowerCase.toLowerCase().startsWith(eventLowerCase)) {
        elt.libelleObjetEntite = elt.libelle;
        this.listPays.push(elt);
        if (this.detail['paysObjet'] && this.detail['paysObjet'].id == elt.id) {
          this.detail['paysObjet'] = elt;
          this.detail['pays'] = elt.libelleObjetEntite;
        }
      }
    });
  }

  searchType(event?) {
    this.result = [];
    let index = 1;
    this.common.getType('typeClient').forEach(elt => {
      elt.libelleObjetEntite = elt.libelle;
      this.result.push(elt);
      if (this.isInfoPart && !this.detail['type'] && this.add) {
        if (elt.libelle === 'Particulier') {
          this.detail['type'] = elt;
        }
      } else {
        if (this.add && !this.detail['type'] && this.typeClientProfessionnel && this.typeClientProfessionnel.id &&
          index === this.typeClientProfessionnel.id) {
          this.detail['type'] = elt;
        }

        if (this.add && this.common.activedModule !== 4 && !this.typeClientProfessionnel) {
          this.detail['type'] = this.result[0];
        }

      }

      // console.log(index, this.add, this.typeClientProfessionnel.id);
      if (this.detail['type'] && this.detail['type'].id === elt.id) {
        this.detail['type'] = elt;
      }

      index++;
    });
  }

  searchCivilite(event?) {
    this.listCivilite = [{ id: 0, libelle: 'Aucune', libelleObjetEntite: 'Aucune' }];
    const list = this.common.getType('typeCivilite') || [];
    list.forEach(elt => {
      // if (elt.libelle.startsWith(event) || elt.libelle.toLowerCase().startsWith(event)) {
      elt.libelleObjetEntite = elt.libelle;
      this.listCivilite.push(elt);
      // }
    });
  }

  searchActivite(event?) {
    this.listActivite = [];
    this.common.getType('typeActivite').forEach(elt => {
      // if (elt.libelle.startsWith(event) || elt.libelle.toLowerCase().startsWith(event)) {
      elt.libelleObjetEntite = elt.libelle;
      this.listActivite.push(elt);
      // }
    });
  }


  verifyPrenom() {
    if (this.common.visibleChamp && this.common.activedModule === 4) {
      if (this.common.visibleChamp.clt158) {
        const idTypeClient = this.detail['type'] ? this.detail['type'].id || 0 : 0;
        const clefTypeClientParticulier = this.societe['typeClientParticulier'] || 0;
        if (idTypeClient === clefTypeClientParticulier) {
          this.isprenomObligatoire = true;
        } else {
          this.isprenomObligatoire = false;
        }
      }
    }
  }

  searchChantier(event) {
    this.detail.listeChantier = [];

    if (!this.detail['prospectHolding']) {
      const param = {
        'servlet': 'DBGetChantierClient',
        'module': 'Recylog',
        'type': 'map',
        'compression': 'false',
        'data': {

          'SITE': {
            'typeParam': 'int',
            'valeur': this.common.user[2]
          },
          'CLEF_CLIENT': {
            'typeParam': 'int',
            'valeur': this.detail['id']// id client
          },
          'CRITERE': event || '' // recherche chantier
        }
      };

      return this.common.post('', { param: param }).then(datas => {
        if (this.common.verifySession(datas)) {
          // $('#autocomplete').trigger('click');
          setTimeout(function () {
            // $('#autocomplete').trigger('click');
          }, 500);
          this.detail.listeChantier = datas.data.length ? datas.data : [];
          this.detail.nbrChantier = datas.data.length;
          this.listeChantier = datas.data;
        }
      });
    } else {
      this.detail['listChantier'] = this.detail['listChantier'] || [];
      this.detail['listChantier'].forEach(elt => {
        if ((elt.numChantier && elt.numChantier.toLowerCase().startsWith(event)) ||
          (elt.responsable && elt.responsable.toLowerCase().startsWith(event)) ||
          (elt.adresse1 && elt.adresse1.toLowerCase().startsWith(event)) ||
          (elt.ville && elt.ville.toLowerCase().startsWith(event))
        ) {
          this.detail.listeChantier.push(elt);
        }
      });
      this.listeChantier = this.detail.listeChantier || [];
    }

  }


  getDetailChantier(event) {
    if (!this.detail['prospectHolding']) {
      const param = {
        'servlet': 'DBGetChantier',
        'module': 'Recylog',
        'type': 'tableau',
        'compression': 'false',
        'data': ['DBGetChantier', event.id]
      };

      return this.common.post('', { param: param }).then(datas => {
        if (this.common.verifySession(datas)) {
          this.chantier = datas.data[0];
          $('.fiche').trigger('click');
        }
      });
    } else {
      this.chantier = event;
    }
  }

  openAdEnvMail() {
    console.log('open AdEnvMail');
    this.adresseDestClient = Object.assign({}, (this.detail['adresseDestClient'] || {}));
    this.common.openModal(this.modalService, this.adEnvMail);
  }

  openVisibilite() {
    this.visibiliteValue = this.detail['visibilite'] ? this.detail['visibilite'].id : 1;
    this.detail['listModule'] = this.detail['listModule'] || [];
    this.listModules.forEach(elt => elt.checked = false);
    if (this.detail['visibilite'] && this.detail['visibilite'].id === 3) {
      this.listModules.forEach(elt => {
        this.detail['listModule'].forEach(elem => {
          if (elem.id === elt.id) {
            elt.checked = true;
          }
        });
      });
    }
    this.common.openModal(this.modalService, this.visibilite);
  }

  openLogo() {
    this.cheminLogo = this.detail['logo'] ? this.common.intercept(this.detail['logo'].NOM_FICHIER) : '';
    this.common.openModal(this.modalService, this.logo);
  }

  openDroitEcoPortail() {
    this.droitEcoGED = Object.assign({}, this.detail['droitEcoGED']);
    if (this.add){
      this.droitEcoGED['nbrMaxMouvContenantJour'] = 3;
    }
    this.common.openModal(this.modalService, this.droitEcoPortail);
  }

  openAccesWidgetEcoPortail() {
    console.log('Calling openAccesWidgetEcoPortail()');
    console.log(this.detail['listeAssoClientWidgetEcoPortail']);
    console.log(this.listeAssoClientWidgetEcoPortailTmp);
    this.listeAssoClientWidgetEcoPortailTmp = this.common.clone(this.detail['listeAssoClientWidgetEcoPortail'] || []);
    this.common.openModal(this.modalService, this.accesWidgetEcoPortail);
  }

  validerAdEnvMail() {
    const adresse = {
      adresseMailBonAchat: this.adresseDestClient['adresseMailBonAchat'] || '',
      adresseMailBonFacturation: this.adresseDestClient['adresseMailBonFacturation'] || '',
      adresseMailBonLogistique: this.adresseDestClient['adresseMailBonLogistique'] || '',
      adresseMailContrat: this.adresseDestClient['adresseMailContrat'] || '',
      adresseMailDevis: this.adresseDestClient['adresseMailDevis'] || '',
      adresseMailFacture: this.adresseDestClient['adresseMailFacture'] || '',
      adresseMailRapport: this.adresseDestClient['adresseMailRapport'] || '',
      adresseMailRelance: this.adresseDestClient['adresseMailRelance'] || '',
      adresseMailTicketPesee: this.adresseDestClient['adresseMailTicketPesee'] || '',
      clefClient: this.detail['id'] || 0,
      nomclass: 'AdresseDestinataireClient'
    };
    this.detail['adresseDestClient'] = this.adresseDestClient;
    const param = {
      'servlet': 'DBGestionAdresseDestClient',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 1
        },
        'ADRESSE_DEST_CLIENT': adresse
      }
    };

    return this.common.post('', { param: param });
  }

  validerVisibilite() {
    this.detail['visibilite'] = this.detail['visibilite'] || {};
    this.detail['visibilite'].id = this.visibiliteValue;
    this.detail['listModule'] = this.listModules.filter(elt => elt.checked === true);
    const selected = this.listModules.filter(elt => elt.checked === true);
    if (this.detail['visibilite'] && this.detail['visibilite'].id === 3 && !(selected || []).length) {
      this.common.errorMsg = 'Vous devez s\u00e9lectionner au moins un module dans lequel le client sera visible';
      this.common.openModal(this.modalService, this.common.msgCommon);
    } else {
      this.common.closeModal();
    }

    /*if (this.visibiliteValue !== 3 || this.visibiliteValue !== '3') {
      this.listModules.forEach( elt => elt.checked = false);
    }*/
  }

  validerLogo() {
    this.detail['fichier'] = this.objFileObject;
  }

  ValiderDroitEcoPortail() {
    this.detail['droitEcoGED'] = this.droitEcoGED;
  }

  validerAccesWidgetEcoPortail() {
    this.detail['listeAssoClientWidgetEcoPortail'] = this.common.clone(this.listeAssoClientWidgetEcoPortailTmp);
  }

  getNameFile(event) {
    const ctrl = this;
    const file = event.target.files[0];

    if (!this.common.checkExtFichierImgEtTexte(file.name)) {
      this.common.error = this.common.msgErreurExtensionFichier;
      this.common.openModal(this.modalService, this.common.popTemplate);
      return;
    }

    ctrl.objFileObject['nomFichier'] = file.name;
    ctrl.objFileObject['nomclass'] = 'FileObject';
    const fileReader = new FileReader();
    fileReader.onload = function () {
      const base64 = (<string>fileReader.result).split(',');
      ctrl.objFileObject['contentBase64'] = base64[1];
      ctrl.cheminLogo = fileReader.result;
    };
    fileReader.readAsDataURL(file);
  }

  getListModule() {
    const param = {
      'servlet': 'DBGetListModule',
      'module': 'Recylog',
      'type': 'tableau',
      'compression': 'false',
      'data': []
    };

    return this.common.post('', { param: param }).then(datas => {
      if (this.common.verifySession(datas)) {
        this.listModules = datas.data;
      }
    });
  }

  changeVisibilite(elem) {
    if (elem !== 3 || elem !== '3') {
      this.listModules.forEach(elt => elt.checked = false);
      this.detail['listModule'] = [];
    }
  }

  showListContact() {
    this.showContact.emit();
  }

  showListUserEcoportail() {
    this.showUserEcoportail.emit();
  }

  showListDocument() {
    this.showDocument.emit();
  }

  showListEntTrav() {
    this.showEntTravaux.emit();
  }

  showFIPDD() {
    this.showGestionFIPDD.emit();
  }

  showFIPDND() {
    this.showGestionFIPDND.emit();
  }

  searchAdresseBAK(event) {
    this.dataAdresseBAK = [];
    const param = {
      'servlet': 'DBGestionAdresseRecherche',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 1
        },
        'CLEF_SITE': {
          'typeParam': 'int',
          'valeur': this.common.user[2]
        },
        'CHAINE_RECHERCHE': event
      }
    };

    return this.common.post('', { param: param }).then(datas => {
      // $('#autocomplete').trigger('click');
      if (this.common.verifySession(datas)) {
        this.dataAdresseBAK = datas.data;
        this.dataAdresseBAK.forEach(elt => {
          elt.id = elt.clefBAK;
          elt.libelleObjetEntite = elt.label;
        });
      }
    });
  }

  setValueAdresseBAK(value, name?) {
    if (value && (!value.numero || (value.numero && value.numero === '0'))) {
      value.numero = '';
    }

    if (name === 'client') {
      this.detail['adresse1'] = `${value.numero || ''} ${value.suffixe || ''}`;
      this.detail['adresse2'] = `${value.typeVoie || ''} ${value.nomVoie || ''}`;
      this.detail['adresse3'] = '';
      this.detail['codePostal'] = value.postcode;
      this.detail['ville'] = value.city;
      this.detail['clefBAK'] = value.clefBAK;
      this.common.bak = value;
    }

    if (name === 'adF') {
      this.detail['adresse1F'] = `${value.numero || ''} ${value.suffixe || ''}`;
      this.detail['adresse2F'] = `${value.typeVoie || ''} ${value.nomVoie || ''}`;
      this.detail['adresse3F'] = '';
      this.detail['cpF'] = value.postcode;
      this.detail['villeF'] = value.city;
    }

    if (name === 'adE') {
      this.detail['adresse1Envoie'] = `${value.numero || ''} ${value.suffixe || ''}`;
      this.detail['adresse2Envoie'] = `${value.typeVoie || ''} ${value.nomVoie || ''}`;
      this.detail['adresse3Envoie'] = '';
      this.detail['cpEnvoie'] = value.postcode;
      this.detail['villeEnvoie'] = value.city;
    }
  }

  addAgence() {
    this.createfctagence.emit();
  }

  editAgence() {
    this.editfctagence.emit(this.agence);
  }

  searchAgence(event?) {
    this.resultAgence = [];
    const param = {
      'servlet': 'DBAgenceGet',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        'CLEF_CLIENT': {
          'typeParam': 'int',
          'valeur': this.detail ? (this.detail.id || 0) : '0'
        },
        'CRITERE': event || '',
      }
    };

    this.common.post('', { param: param }).then(datas => {
      this.listeagence = datas.data;
      this.listeagence.forEach(elt => {
        elt.libelleObjetEntite = elt.nom;
        this.resultAgence.push(elt);
      });
    });
  }


  searchSiren(event) {
    if (event.length === 14 && !event.includes(' ')) {
      this.isInfoSiretOpen = false;
      this.detail['siren'] = event;

      if (this.detail['type'] && this.detail['type'].id === 1 && event && event.includes('.')) {
        this.common.error = 'Siren incorrect';
        this.common.msgError = true;
        this.common.openModal(this.modalService, this.common.popTemplate);
        return false;
      }

      this.dataSiren = [];
      const param = {
        'servlet': 'DBGestionBaseSirene',
        'module': 'Recylog',
        'type': 'map',
        'compression': 'false',
        'data': {
          'OPERATION': {
            'typeParam': 'int',
            'valeur': 2
          },
          'SIRENE': event,
        }
      };

      return this.common.post('', { param: param }).then(datas => {
        // $('#autocomplete').trigger('click');
        if (this.common.verifySession(datas)) {
          this.dataSiren = datas.data;
          this.dataSiren.forEach(elt => {
            const siege_social = elt.siege_social || {};
            /*elt.libelleObjetEntite = `${siege_social.siren || event} : ${siege_social.nom_raison_sociale
              || ''} : ${elt.numero_tva_intra || ''}`;*/
            elt.libelleObjetEntite = `${siege_social.siren || event} : ${siege_social.nom_raison_sociale
              || ''}`;
          });
        }
      }).catch(err => {
        if (this.common.local.get('numautocomplete')) {
          if (this.common.waitProm.doSomething[this.common.local.get('numautocomplete')]) {
            this.common.waitProm.doSomething[this.common.local.get('numautocomplete')].next([]);
          }
        }
      });
    } else {
      this.isInfoSiretOpen = true
    }

  }

  keyUpInputSiret($event) {
    if ($event) {
      this.isInfoSiretOpen = $event.length != 14 || $event.includes(' ');
    }
  }

  blurInputSiret() {
    this.isInfoSiretOpen = false;
  }

  setValueSiren(event) {
    const siege_social = event.siege_social || {};
    this.detail.nomClient = siege_social.nom_raison_sociale || '';
    this.detail.siren = siege_social.siren || '';
    this.detail.siret = siege_social.siret || '';
    this.detail.codeTVAIntra = event.numero_tva_intra || '';
  }


  getListOperationBennePortail() {
     const param = {
        'servlet': 'DBGestionOperationBenne',
        'module': 'Recylog',
        'type': 'map',
        'compression': 'false',
        'data': {
          'OPERATION': {
            'typeParam': 'int',
            'valeur': 4
          }
        }
      };

    return this.common.post('', { param: param }).then(datas => {
      if (this.common.verifySession(datas)) {
        const data = datas.data || [];
        this.listOperationBennePortail = data.filter(elt => 
          elt.operationBenneVisiblePortail
        ) || [];
      }
    });
  }

  traiterOperationBennePortailVisible(): void {
    const listDetail = this.detail.listOperationBenne ?? [];
    this.listOperationBennePortail.forEach(el => {
      el.operationBenneVisiblePortailClient = listDetail.some(
        elem =>
          elem.id === el.id &&
          elem.operationBenneVisiblePortailClient
      );
    });
  }

  openModalOperationBenne() {
    if (this.detail['id'] && this.detail['id'] != 0) {
      this.traiterOperationBennePortailVisible();
    }
    this.common.openModal(this.modalService, this.choixOperationBennePortail);
  }    

  validerAccesOperationBennePortail() {
    this.listOperationBennePortail = this.listOperationBennePortail || [];
    this.detail['listOperationBenne'] = this.listOperationBennePortail
  }
}
